import React from 'react';
import styles from './styles.module.less';
import loading from 'static/ripples.svg';
// import logo from 'static/logo-square.png';

const Fallback = () => {

  return (
    <div className={styles.fallback}>
      <img src={loading} className={styles.loading} alt="loading" width="46"/>
    </div>
  )
}

export default Fallback;